import React, { useState } from "react";
import {Checkbox, makeStyles} from "@material-ui/core";
import { highlightColorRGBA } from "./HighlightColor";
import useReactiveFunctionWithDebouncing from "./useReactiveFunctionWithDebouncing";

const useStyles = makeStyles((theme) => ({
  highlighted: {
    backgroundColor: highlightColorRGBA + ' !important', // !important pro hover não sobrescrever
  }
}));

export default function HighlightableCheckbox({ isHighlightedFunction, safeToHighlight = true, className, ...props }) {
  const { checked: value } = props;
  const [highlighted, setHighlighted] = useState(isHighlightedFunction(value));
  const classes = useStyles();
  
  useReactiveFunctionWithDebouncing({
                              functionn: isHighlightedFunction,
                              reactiveArgument: value,
                              safeToRun: safeToHighlight,
                              setReturnedValue: setHighlighted,
                              noDebouncing: true
                            });
  
  
  return (
    <Checkbox {...props} className={`${className ?? ''} ${highlighted ? classes.highlighted : ''}`}/>
  );
}
